import { Navigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth, db } from '../firebaseConfig';
import { doc, getDoc } from "firebase/firestore";

import { hasUserEmailBeenVeridied } from "./FunctionCalls";

const ProtectedRoute = ({ element, role }) => {
  let location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const idParam = searchParams.get("id"); 

  const [user, setUser] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [authCheckComplete, setAuthCheckComplete] = useState(false);
  const [emailVerifiedCheckComplete, setEmailVerifiedCheckComplete] = useState(false);
  const [isEmailVerified, setIsEmailVerified] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      setUser(currentUser);

      if (!currentUser) {
        setAuthCheckComplete(true);
        return;
      }

      // Role check
      if (role) {
        try {
          const docRef = doc(db, "appUsers", currentUser.uid);
          const docSnap = await getDoc(docRef);
          if (docSnap.exists()) {
            setUserRole(docSnap.data().role);
          }
        } catch (error) {
          console.error("Error fetching user role:", error);
        }
      }

      // Email verification check
      if (!currentUser.emailVerified) {
        try {
          const verified = await hasUserEmailBeenVeridied(currentUser.email, auth);
          setIsEmailVerified(verified);
        } catch (error) {
          console.error("Error checking email verification:", error);
          setIsEmailVerified(false);
        }
      } else {
        setIsEmailVerified(true);
      }

      setEmailVerifiedCheckComplete(true);
      setAuthCheckComplete(true);
    });

    return () => unsubscribe();
  }, [role]);

  if (!authCheckComplete || (role && user && userRole === null) || (user && !user.emailVerified && !emailVerifiedCheckComplete)) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location, id:idParam }} replace />;
  }

  if (!user.emailVerified && !isEmailVerified) {
    return <Navigate to="/signup?action=email-verification-required" state={{ from: location, id:idParam }} replace />;
  }

  if (role && userRole !== role) {
    return <Navigate to="/unauthorized" replace />;
  }

  return element;
};

export default ProtectedRoute;
